import type { MouseEvent } from 'react'
import { CHECKOUT_URL } from '../data/content'
import { trackCheckoutIntent } from './analytics'

/**
 * Abre el checkout externo en una pestaña nueva.
 * Se fuerza con window.open para que funcione también cuando la página
 * se muestra dentro de un iframe (preview del editor, embeds, etc.).
 */
export function goToCheckout(
  event: MouseEvent<HTMLAnchorElement>,
  location: string,
): void {
  trackCheckoutIntent(location)
  event.preventDefault()

  const opened = window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer')
  if (opened) return

  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = CHECKOUT_URL
      return
    }
  } catch {
    // Si el navegador bloquea el acceso al frame superior, seguimos en el frame actual.
  }

  window.location.href = CHECKOUT_URL
}
